
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"29"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0a294a","d":"M11.764 7.862c-.537.535-.802 1.171-.793 1.911.008.74.272 1.368.793 1.887l3.913 3.75-3.913 3.889-.103.108a2.539 2.539 0 00-.69 1.801 2.6 2.6 0 00.794 1.887 2.635 2.635 0 001.899.79c.744.007 1.383-.256 1.92-.79l5.959-6.03.083-.088c.834-.933.8-2.36-.098-3.253l-5.92-5.884-.107-.1c-.5-.451-1.102-.677-1.803-.677-.753 0-1.397.266-1.934.8zm17.917 7.611c0 7.848-6.401 14.21-14.298 14.21-7.817 0-14.17-6.235-14.296-13.975l-.002-.235.002-.235c.126-7.74 6.479-13.974 14.296-13.974 7.897 0 14.298 6.362 14.298 14.21zM.557 15.23l-.002.243.002.244c.13 8.027 6.718 14.493 14.826 14.493 8.19 0 14.828-6.598 14.828-14.737S23.573.736 15.383.736C7.276.736.688 7.203.557 15.23z"}})])
          )
        }
      }
    